import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/kenneth/Sites/typebrigade/typebrigade.com/src/components/TemplateBlogPost.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Sponsors`}</h1>
    <p>{`Type Brigade is Vancouver’s typography meetup. We’ve been getting together since 2011, and now have well over 1,500 talented and curious communication designers, visual artists, web developers, and type fans, ready to meet and learn about typography, design, and anything connected to it.`}</p>
    <p>{`The current organising team has been running speaker series events for the last 5 years, and we typically run 5 or 6 free events per year, occasionally facilitate paid workshops.`}</p>
    <p>{`In 2020, we’re doing something new: our first one-day conference.`}</p>
    <h2>{`Open Sponsorship`}</h2>
    <p>{`If you are:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Hiring`}</strong>{` Interested in finding designers in Vancouver to hire`}</li>
      <li parentName="ul"><strong parentName="li">{`Sharing`}</strong>{` Building a product for people who use design and media tools`}</li>
      <li parentName="ul"><strong parentName="li">{`Introducing`}</strong>{` A studio or agency looking to become more well known in Vancouver, and want to help growing the design community here`}</li>
    </ul>
    <p>{`…sponsoring Type Brigade is an easy and inexpensive way to help while supporting a well-received local event. Send us an email using the following button, or email kenneth@typebrigade.com`}</p>
    <a className="Button Button--small" href="mailto:kenneth@typebrigade.com?subject=Sponsorship">I’m interested in sponsoring</a>
    <h2>{`Sponsor perks`}</h2>
    <p>{`We’ll provide you with our full Type Brigade №50 conference sponsorship package via email.`}</p>
    <p>{`Sponsorships for our typical monthly events include:`}</p>
    <ul>
      <li parentName="ul">{`The host will give you two shout-outs during the meetup while your link and logo or supplied slide is on the screen (once at the beginning, and once at the end)`}</li>
      <li parentName="ul">{`If you are promoting a specific job post or event, we’ll`}</li>
      <li parentName="ul">{`Link and logo on the Type Brigade website`}</li>
      <li parentName="ul">{`We can hold some reserved spots to the meetup for you or members of your team`}</li>
      <li parentName="ul">{`You can bring swag to give out when we sign people in and during the meetup, ex. promotional post card`}</li>
      <li parentName="ul">{`We’ll also tweet out your link and message from `}<a parentName="li" {...{
          "href": "https://twitter.com/typebrigade"
        }}>{`@typebrigade`}</a>{` account leading up to and after the event`}</li>
    </ul>
    <p>{`If you have questions or are interested in sponsoring this or a future even, please `}<a parentName="p" {...{
        "href": "mailto:kenneth@typebrigade.com"
      }}>{`send Kenneth an email`}</a>{`!`}</p>
    {
      /*
      _Previous and ongoing sponsors of Type Brigade have included [MetaLab](http://metalab.co), [Hootsuite](http://hootsuite.com), [Lost Type](http://losttype.com), [CodeCore](http://codecore.ca), [Microsoft](https://mcec.microsoft.ca/), [BrainStation](https://brainstation.io/), and [Mobify](http://mobify.com/jobs)._
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      